import { action } from 'easy-peasy';
import { IActionSetMoreStatusMobileUsers } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreStatusMobileUsers: IActionSetMoreStatusMobileUsers = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.mobileUsers.length;

  const newItems = mergeUniqueBy(
    state.statusMobileUsers.mobileUsers,
    payload.mobileUsers,
    item => item.id,
  );

  state.statusMobileUsers.mobileUsers = [...newItems];
  state.statusMobileUsers.total = payload.total;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreStatusMobileUsers;
